import React, { useState, useRef, useEffect } from "react";
import {
  Button,
  Flex,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Spinner,
  Divider,
} from "@chakra-ui/react";
import Login from "../../../../services/loginApi";
import apiPagamentoDireto from "../../../../services/apiPagamentoDireto";
import { toast } from "react-toastify";
import bancos from "bancos-brasileiros";
import { useNavigate } from "react-router-dom";
import {
  goToPaymentSolicitationListNew,
  goToTransferSolicitationListNew,
} from "../../../../routes/coordinator";
import {
  CPFFormater,
  CNPJFormater,
} from "../../../../defaultFunctions/formaters";
import { BLACK } from "../../../../constants/colors";
import { NumericFormat } from "react-number-format";
const ModalSendACodeToLogin = ({
  isOpen,
  setIsOpen,
  functionPai,
  setCode,
  type,
  email,
  transferData,
}: any) => {
  const finalRef = useRef(null);
  const navigate = useNavigate();
  const [confirmation, setConfirmation] = useState(false);
  const [codes, setCodes] = useState<string[]>(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState<any[]>([]);
  const inputsRef = useRef<HTMLInputElement[]>([]);
  const [pagamentoResponse, setpagamentoResponse] = useState<any>(null);
  const [pagamentoId, setpagamentoId] = useState<number | null>(null);
  const [statusSucesso, setStatusSucesso] = useState(false);
  const [manualValue, setManualValue] = useState<number>(0);

  const handleClose = () => {
    setIsOpen(false);
    setpagamentoResponse(null);
    setManualValue(0);
  };

  const fetchTransferData = async () => {
    setLoading(true);
    setErrors([]);
    try {
      const response = await apiPagamentoDireto.postPaymentSolicitation(
        transferData
      );
      setStatusSucesso(false);

      if (response.beneficiary === null && response.concessionary === null) {
        setErrors(
          response._errors || [
            { _message: response._message || "Erro desconhecido" },
          ]
        );
      }

      setpagamentoId(response.idPagamento);
      setpagamentoResponse(response);
      setLoading(false);
    } catch (error: any) {
      setStatusSucesso(true);
      if (
        error.response &&
        error.response.data &&
        error.response.data._errors
      ) {
        setErrors(error.response.data._errors);
      } else {
        handleClose();
        toast.error(
          `Falha ao solicitar Pagamento: ${
            error?.response?.data || error.message
          }`
        );
      }
      setLoading(false);
    }
  };

  const handleCancelTransfer = async () => {
    if (pagamentoResponse && pagamentoResponse.idPagamento) {
      try {
        // await apiPagamentoDireto.deletePaymentPerId(pagamentoResponse.idPagamento, {});
        toast.success("Pagamento cancelado com sucesso!");
        handleClose();
      } catch (error) {
        toast.error(`Falha ao cancelar Pagamento: ${error}`);
        console.error("Erro ao cancelar Pagamento:", error);
      }
    } else {
      toast.error("ID do Pagamento não encontrado.");
    }
  };

  const handleConfirmation = async (confirm: boolean) => {
    if (confirm) {
      setConfirmation(true);
      try {
        await Login.GetNewCodeEmail(type, email);
        toast.success(
          "Você receberá um e-mail ou SMS com o código de segurança!"
        );
      } catch (error) {
        toast.error(`Falha ao solicitar código de segurança: ${error}`);
      }
    } else {
      handleClose();
    }
  };

  const handleChange = (index: number, value: string) => {
    const newCodes = [...codes];
    newCodes[index] = value.replace(/\D/g, "").slice(0, 11); // Keeping up to 11 numeric characters
    setCodes(newCodes);
    if (value && index < codes.length - 1) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (
    index: number,
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (event.key === "Backspace" && !codes[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };
  const unMask = (value: string | number) => {
    if (typeof value !== "string" && typeof value !== "number") {
      return 0;
    } else if (typeof value == "number") return value;

    let valorSemSimbolo = value.replace("R$ ", "");
    let valorSemPontos = valorSemSimbolo.replace(",", ".");
    if (
      !valorSemPontos ||
      valorSemPontos == "" ||
      valorSemPontos == undefined ||
      valorSemPontos == null
    ) {
      return 0;
    }

    return parseFloat(valorSemPontos);
  };

  const handleSubmit = async () => {
    const code = codes.join("");
    setCode(code);
    setLoading(true);
    setErrors([]);

    try {
      // Obter o valor de pagamento sem formatação de moeda usando unMask
      const valorPagamentoDesformatado = unMask(
        manualValue !== null ? manualValue : pagamentoResponse.totalValue
      );

      // Enviar para a API
      await apiPagamentoDireto.confirmPayment(
        pagamentoResponse.idPagamento,
        code,
        valorPagamentoDesformatado
      );

      // Navegar para a lista de solicitações de pagamento
      goToPaymentSolicitationListNew(navigate);
      handleClose();
    } catch (error: any) {
      if (
        error.response &&
        error.response.data &&
        error.response.data._errors
      ) {
        setErrors(error.response.data._errors);
      } else {
        toast.error(
          `Falha ao confirmar Pagamento: ${
            (error.response && error.response.data) || error.message
          }`
        );
      }
      setLoading(false);
      // handleClose();
    }
  };

  const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    const paste: any = event.clipboardData.getData("text").slice(0, 6); // Limita ao tamanho dos inputs
    const newCodes: any = [...paste].map((char) => char.replace(/\D/g, ""));
    setCodes(newCodes);

    newCodes.forEach((value: any, index: any) => {
      if (inputsRef.current[index]) {
        inputsRef.current[index].value = value;
      }
    });

    // Foca no próximo input após o último preenchido
    const nextIndex = paste.length < 6 ? paste.length : 5;
    if (inputsRef.current[nextIndex]) {
      inputsRef.current[nextIndex].focus();
    }
  };

  // TESTE
  /*  const handleSubmit = async () => {
    const code = codes.join("");
    setCode(code);
    setLoading(true);
    setErrors([]);
  
    try {
      // Aplicando unMask ao valor de pagamento
      const valorPagamentoDesformatado = unMask(manualValue !== null ? manualValue : pagamentoResponse.totalValue);
  
      console.log("Dados enviados para a API:", {
        idPagamento: pagamentoResponse.idPagamento,
        codigo: code,
        valorPagamento: valorPagamentoDesformatado,
      });
  
      // Aqui você envia os dados para a API, incluindo o valor de pagamento desformatado
  
      toast.success("Pagamento confirmado com sucesso!");
  
    } catch (error) {
      toast.error(`Falha ao confirmar Pagamento: ${error}`);
      setLoading(false);
      handleClose();
    }
  }; */
  useEffect(() => {
    if (isOpen) {
      setConfirmation(false);
      setCodes(["", "", "", "", "", ""]);
      fetchTransferData();
    }
  }, [isOpen]);

  const labelMappings: { [key: string]: string } = {
    nominalValue: "Valor Nominal",
    deductedValue: "Descontos",
    addedValue: "Juros/Multa",
    totalValue: "Valor Pagamento",
    name: "Beneficiário",
    document: "Documento Beneficiário",
    dueDate: "Data de Vencimento",
    code: "Código de Barras/Linha Digitável",
  };

  const renderErrors = (errors: any[]) => {
    return (
      <Flex direction="column" alignItems="center" mt={4}>
        {errors.map((error, index) => (
          <Text key={index} color="red.500">
            {error._message}
          </Text>
        ))}
      </Flex>
    );
  };

  const formatCurrency = (value: number) => {
    return `R$ ${value.toFixed(2).replace(".", ",")}`;
  };

  return (
    <Modal
      finalFocusRef={finalRef}
      isOpen={isOpen}
      onClose={handleClose}
      size={"xl"}
      closeOnEsc={false}
      closeOnOverlayClick={false}
    >
      <ModalOverlay backdropFilter="blur(10px)" />
      <ModalContent>
        <ModalHeader>
          <Flex w={"100%"} justifyContent={"center"} my={2}>
            <Text fontSize={"xl"} fontWeight={"bold"}>
              {!confirmation
                ? loading
                  ? "Carregando..."
                  : "Confira os dados para confirmar o pagamento:"
                : "Digite seu código de verificação"}
            </Text>
          </Flex>
        </ModalHeader>
        <ModalBody>
          {loading ? (
            <Flex justifyContent="center" alignItems="center" height="200px">
              <Spinner size="xl" />
            </Flex>
          ) : !confirmation ? (
            <Flex direction="column" alignItems="center">
              {errors.length > 0 && renderErrors(errors)}
              {pagamentoResponse && pagamentoResponse.beneficiary && (
                <Flex direction="column" alignItems="start">
                  <Text>
                    <strong>Código de Barras/Linha Digitável:</strong>{" "}
                    {pagamentoResponse.code}
                  </Text>
                  <Text>
                    <strong>Nome do Beneficiário:</strong>{" "}
                    {pagamentoResponse.beneficiary.name}
                  </Text>
                  <Text>
                    <strong>Tipo de Documento:</strong>{" "}
                    {pagamentoResponse.beneficiary.documentType}
                  </Text>
                  <Text>
                    <strong>Número do Documento:</strong>{" "}
                    {pagamentoResponse.beneficiary.documentNumber.length === 14
                      ? CNPJFormater(
                          pagamentoResponse.beneficiary.documentNumber
                        )
                      : CPFFormater(
                          pagamentoResponse.beneficiary.documentNumber
                        )}
                  </Text>
                  <Text>
                    <strong>Pagamento Mínimo:</strong>{" "}
                    {formatCurrency(
                      pagamentoResponse?.partialPayment?.min || 0
                    )}
                  </Text>
                  <Text>
                    <strong>Valor Nominal:</strong>{" "}
                    {formatCurrency(pagamentoResponse.nominalValue)}
                  </Text>
                  <Text>
                    <strong>Juros/Multa:</strong>{" "}
                    {formatCurrency(pagamentoResponse.addedValue)}
                  </Text>
                  <Text>
                    <strong>Descontos:</strong>{" "}
                    {formatCurrency(pagamentoResponse.deductedValue)}
                  </Text>
                  <Divider variant="solid" color={BLACK}></Divider>
                  <Flex direction="column" alignItems="center" width={"100%"}>
                    <Text>
                      <strong>Valor Pagamento:</strong>{" "}
                      {pagamentoResponse && pagamentoResponse.totalValue > 0 ? (
                        pagamentoResponse.totalValue.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })
                      ) : (
                        <>
                          <strong>Boleto sem valor determinado.</strong>
                          <NumericFormat
                            decimalScale={2}
                            prefix="R$ "
                            value={
                              manualValue !== null ? manualValue.toString() : ""
                            }
                            decimalSeparator=","
                            customInput={Input}
                            type="text"
                            placeholder="R$ 0,00"
                            onChange={(e: any) => {
                              setManualValue(e.target.value);
                            }}
                          />
                          {!(unMask(manualValue.toString()) > 0) && (
                            <Text fontSize="sm" color="gray.500">
                              É necessário definir um valor para seguir com o
                              pagamento. Em caso de dúvidas, consulte o
                              beneficiário.
                            </Text>
                          )}
                        </>
                      )}
                    </Text>
                  </Flex>
                </Flex>
              )}
              {pagamentoResponse && pagamentoResponse.concessionary && (
                <Flex direction="column" alignItems="start">
                  <Text>
                    <strong>Código de Barras/Linha Digitável:</strong>{" "}
                    {pagamentoResponse.code}
                  </Text>
                  <Text>
                    <strong>Nome do Beneficiário:</strong>{" "}
                    {pagamentoResponse.concessionary.name}
                  </Text>
                  <Text>
                    <strong>Código de Identificação do Beneficiário:</strong>{" "}
                    {pagamentoResponse.concessionary.code}
                  </Text>
                  <br />
                  <Divider variant="solid" color={BLACK}></Divider>
                  <Flex direction="column" alignItems="center" width={"100%"}>
                    <Text>
                      <strong>Valor Pagamento:</strong>{" "}
                      {pagamentoResponse.totalValue > 0 ? (
                        formatCurrency(pagamentoResponse.totalValue)
                      ) : (
                        <Input
                          value={manualValue || ""}
                          onChange={(e) =>
                            setManualValue(parseFloat(e.target.value))
                          }
                        />
                      )}
                    </Text>
                  </Flex>
                </Flex>
              )}
              {errors.length === 0 && transferData && (
                <Flex direction="column" alignItems="center"></Flex>
              )}
              <Flex mt={4}>
                <Button
                  m={2}
                  onClick={() => handleConfirmation(true)}
                  colorScheme="blue"
                  disabled={
                    errors.length > 0 ||
                    statusSucesso ||
                    (pagamentoResponse &&
                      pagamentoResponse.totalValue == 0 &&
                      !(unMask(manualValue.toString()) > 0))
                  }
                >
                  Sim
                </Button>
                <Button m={2} onClick={handleCancelTransfer} colorScheme="gray">
                  Cancelar
                </Button>
              </Flex>
            </Flex>
          ) : (
            <Flex w={"100%"} justifyContent={"center"}>
              {codes.map((value, index) => (
                <Input
                  key={index}
                  ref={(el) =>
                    (inputsRef.current[index] = el as HTMLInputElement)
                  }
                  type="text"
                  maxLength={1}
                  width="3rem"
                  textAlign="center"
                  value={value}
                  onChange={(e) => handleChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  onPaste={handlePaste}
                  marginRight={2}
                />
              ))}
            </Flex>
          )}
        </ModalBody>
        <ModalFooter justifyContent={"space-evenly"}>
          {confirmation && (
            <Button
              mt={4}
              onClick={handleSubmit}
              disabled={codes.some((code) => !code)}
            >
              Confirmar código
            </Button>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ModalSendACodeToLogin;
